'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface FeedbackSuccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function FeedbackSuccessModal({ open, onOpenChange }: FeedbackSuccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="mx-4 max-w-md overflow-hidden rounded-lg border-0 bg-surface-4 p-0 text-text-strong"
        showCloseButton={false}
        onInteractOutside={(e) => {
          // Prevent closing modal when clicking outside
          e.preventDefault();
        }}
        onEscapeKeyDown={(e) => {
          // Prevent closing modal when pressing Escape
          e.preventDefault();
        }}
      >
        <div className="space-y-6 p-8 text-center">
          <DialogHeader className="space-y-4">
            <DialogTitle className="text-center text-2xl leading-tight font-normal text-text-strong md:text-3xl">
              Feedback
            </DialogTitle>
            <DialogDescription className="text-center text-base text-text-medium md:text-lg">
              Thank you for sharing your feedback!
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="mt-4">
            <DialogClose asChild>
              <Button
                variant="PrimaryFillButton"
                className="flex w-full items-center justify-center rounded-none bg-primary-accent px-6 py-3 text-base font-medium text-black hover:bg-primary-accent/90"
              >
                Close
              </Button>
            </DialogClose>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
